import { render, staticRenderFns } from "./ChannelSettings.vue?vue&type=template&id=e57be78a&scoped=true&"
import script from "./ChannelSettings.vue?vue&type=script&lang=js&"
export * from "./ChannelSettings.vue?vue&type=script&lang=js&"
import style0 from "./ChannelSettings.vue?vue&type=style&index=0&id=e57be78a&prod&lang=css&"
import style1 from "./ChannelSettings.vue?vue&type=style&index=1&id=e57be78a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57be78a",
  null
  
)

export default component.exports